/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PensionContractStatus = {
    Active: 'Active',
    Inactive: 'Inactive',
    Pending: 'Pending',
    Proposal: 'Proposal'
} as const;
export type PensionContractStatus = typeof PensionContractStatus[keyof typeof PensionContractStatus];


export function instanceOfPensionContractStatus(value: any): boolean {
    for (const key in PensionContractStatus) {
        if (Object.prototype.hasOwnProperty.call(PensionContractStatus, key)) {
            if (PensionContractStatus[key as keyof typeof PensionContractStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PensionContractStatusFromJSON(json: any): PensionContractStatus {
    return PensionContractStatusFromJSONTyped(json, false);
}

export function PensionContractStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PensionContractStatus {
    return json as PensionContractStatus;
}

export function PensionContractStatusToJSON(value?: PensionContractStatus | null): any {
    return value as any;
}

export function PensionContractStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): PensionContractStatus {
    return value as PensionContractStatus;
}

